<template>
  <div class="modal h-100" ref="modal" id="settings" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document" :style="licenseExpMess && licenseExpMess.trim().length?'height:calc(100% - 30px)':'height:100%'">
      <div class="modal-content full-screen-settings">
        <div class="modal-header p-2">
          <h4 class="modal-title ml-2">{{$t('Settings')}}</h4>
          <button class="close text-white" data-dismiss="modal" :style="close" aria-label="Close" @click="close" :isSettings="showSettings">
            <span aria-hidden="true"><h2><cancel-icon class="close-icon" style="height: 35px !important;
      width: 35px !important;
      color: #fff;"></cancel-icon></h2></span>
          </button>
        </div>
        <div class="modal-body p-0">
            <div class="container-fluid sidenav">
                      <div style="height:inherit;display:inline-flex;width:100%">
                        <div class="col-md-2 h-100 p-0" :style="[ isFullScreen ? {display: 'none'}: {display: 'block'}]">
                          <nav class="sidebar-wrapper h-100">
                          <ul class="sidebar-menu m-0 h-100" style="list-style-type:none;padding:4px">
                            <li class="sidebar text-left" v-for="panel in getRegisteredSettingsSidemenu()" :class="{activeclass:getSelectedSettingsSidemenu == panel.id}" :id="panel.id" v-on:click="getEventHandler('onClick',panel.onEvents, panel)" :key="panel.label"
                              :style="(panel.id == 'assetlinktypes')?'padding:0px 14px 0px 24px!important':''">                          
                              <span class="m-0 option-label" style="padding:4% 0%"><span v-html="panel.iconSvgCallback('','20px','20px')" style="margin-inline-end:16px;"></span>{{$t(panel.label)}}</span>
                            </li>
                          </ul>
                          </nav>
                        </div>
                        <div class="p-0 h-100" :class="[ isFullScreen ? 'col-md-12' : 'col-md-10']">
                            <router-view :name="selectedComponent" v-bind="currentProperties" v-on:fullscreenDisplayRequest="openFullScreen" class="h-100"></router-view>
                        </div>
                      </div>
                  </div>
        </div>
       <!-- <settings-footer></settings-footer> -->
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import {mapGetters,mapActions,mapMutations} from "vuex"
  import {SettingsSideMenu} from "../../registry/plugins.js"
  
  // import Footer from "./Footer.vue";
  import Utils from "../../components.utils.js"
  import cancelIcon from "../core/InlineCancelField.vue"
  
  export default {
    name: "Settings",
      components:{
          // 'settings-footer':Footer,
          'cancel-icon':cancelIcon,
      },
      computed:{
        ...mapGetters("settings",["getSelectedSettingsSidemenu"]),
        currentProperties() {
          if (this.selectedComponent === "settings-pluginloader") {
              return { pluginInfo : this.selectedPluginInfo};
          }
          else{
              return {}
          }
        },
      },
      watch:{
        "$route.fullPath":function(newVal,oldVal){
          if (newVal!=oldVal){
            if (this.$route.matched[this.$route.matched.length-1].parent.name == "settings" && this.selectedComponent != this.$route.name){
              this.changeToSelectedComponent(this.$route.name, this.$route.params.pluginId?this.$route.params.pluginId:this.$route.name.split("-")[1], false)
            }
          }
        },
      },
      data(){
          return { 
              activeIndex: "",
              showSettings: true,
              userSettings : [],
              sideMenuList:["metadata","field","screen","screen profile","user","bin","system","plugins","import","Web hook","scheduler", "AI", "media pipeline", "labels","Asset Link Types", "alias","buttons", "license"],
              sideMenuListIds:["alias","metadata","field","screen","screenprofile","user","bin","system","plugin","import","webhook","scheduler", "AI", "mediapipeline", "labels","assetlinktypes","buttons", "license"],
              componentsList:["settings-alias","settings-metadata","settings-user","settings-bin","settings-field","settings-screen","settings-screenprofile","settings-import","settings-system","settings-plugin", "settings-AI", "settings-mediapipeline","settings-labels", "settings-assetlinktypes", "settings-buttons", "settings-license"],
              isClosed:false,
              selectedComponent : "",
              selectedPluginInfo:null,
              isFullScreen:false,
              parentRouteInfo:{},
              licenseExpMess:undefined
          }
      },
      methods:{
          isActiveComp(comp){
            return this.selectedComponent == comp
          },
          isUserSettingsLoaded(){
            return (this.userSettings.length != 0)
          },
          changeToSelectedComponent(compName,id, push=true){
            console.log("compNamecompName",compName,id)
              this.selectedComponent = compName;
              this.setSelectedSettingsSidemenu(id);
              let route = {name: compName}
              if (this.selectedComponent == "settings-pluginloader" && id){
                route.params = {pluginId: id}
              }else{
                this.isFullScreen = false
              }
              if (push){
                this.$router.push(route);
                // this.reloadSettingsSideMenuList();
              }
              // this.$emit("changeToSelectedComponent", compName, {})
          },
          changeComponentToMetadata(){
              this.changeToSelectedComponent("settings-metadata","metadata");
              this.setSelectedSettingsSidemenu("metadata");
          },
          changeComponentToAlias(){
            this.changeToSelectedComponent("settings-alias","alias");
            this.setSelectedSettingsSidemenu("alias");
          },
          changeComponentToUsers(){
              this.changeToSelectedComponent("settings-user","user");
              this.setSelectedSettingsSidemenu("user");
          },
          changeComponentToBins(){
              this.changeToSelectedComponent("settings-bin","bin");
              this.setSelectedSettingsSidemenu("bin");
          },
          /**************** AI ************** */
          changeComponentToAI(){
              this.changeToSelectedComponent("settings-AI","AI");
              this.setSelectedSettingsSidemenu("AI");
          },
  
          /*************************** */
          changeComponentToFields(){
             this.changeToSelectedComponent("settings-field","field");
             this.setSelectedSettingsSidemenu("field");
          },
          changeComponentToScreens(){
             this.changeToSelectedComponent("settings-screen","screen");
             this.setSelectedSettingsSidemenu("screen");
          },
          changeComponentToScreenProfiles(){
            this.changeToSelectedComponent("settings-screenprofile","screenprofile");
            this.setSelectedSettingsSidemenu("screenprofile");
          },
          changeComponentToImport(){
              this.changeToSelectedComponent("settings-import","import");
              this.setSelectedSettingsSidemenu("import");
          },
          changeComponentTowebhook(){
            this.changeToSelectedComponent("settings-webhook","webhook");
            this.setSelectedSettingsSidemenu("webhook");
          },
          changeComponentToScheduler(){
            this.changeToSelectedComponent("settings-scheduler","scheduler");
            this.setSelectedSettingsSidemenu("scheduler");
          },
          
          changeComponentToMediaPipeline(){
            this.changeToSelectedComponent("settings-mediapipeline","mediapipeline");
            this.setSelectedSettingsSidemenu("mediapipeline");
          },
          changeComponentToSystem(){
              this.changeToSelectedComponent("settings-system","system");
              this.setSelectedSettingsSidemenu("system");
          },
          changeComponentToPlugins(){
              this.changeToSelectedComponent("settings-plugin","plugin");
              this.setSelectedSettingsSidemenu("plugin");
          },
          changeComponentToLabels(){
            this.changeToSelectedComponent("settings-labels","labels");
            this.setSelectedSettingsSidemenu("labels");
          },
          changeComponentToAssetLinkTypes(){
            this.changeToSelectedComponent("settings-assetlinktypes","assetlinktypes");
            this.setSelectedSettingsSidemenu("assetlinktypes");
          },
          changeComponentToExternalPlugin(id){
              this.changeToSelectedComponent("settings-pluginloader",id)
              this.setSelectedSettingsSidemenu(id);
          },
          changeComponentToButtons(){
            this.changeToSelectedComponent("settings-buttons","buttons");
            this.setSelectedSettingsSidemenu("buttons");
          },
          changeComponentToLicense(){
            this.changeToSelectedComponent("settings-license","license");
            this.setSelectedSettingsSidemenu("license");
          },
          isComponentEnabled(settingsName){
            return (this.isUserSettingsLoaded() && (this.isSettingsEnabledForUser(settingsName)))
          },
          isSettingsEnabledForUser(settingsName){
            return this.userSettings.user_settings[0].enabled_settings.includes(settingsName)
          },
          isEnabled(settingsName){
            let settingsPrivMapper = {
              "bin":"manage-bins",
              // "metadata": ["manage-catalogs","manage-tags"]
              "metadata": ["manage-tags"]
            }
            let privName = settingsName;
            if(Object.keys(settingsPrivMapper).includes(settingsName)){
              privName = settingsPrivMapper[settingsName];
            }
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(),privName)
          },
          isProfileConfigured(){
            if('screen_profile_required' in this.getStartUpDataFromInCache()){
              return this.getStartUpDataFromInCache()["screen_profile_required"];
            }
            return true;
          },
          close() {
            // this.unsetLocationChangeEventListenerCallback()
            this.isClosed = true
            // this.$emit('close');
            if (Object.keys(this.parentRouteInfo)!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
              this.$router.push({
                name: this.parentRouteInfo.name,
                params:this.parentRouteInfo.params,
                query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
              })
            }else{
              this.$router.push({
                name: "explorer",
              })
            }
            // Utils.updateCookieByKeyName("context","bins-display")
          },
          openFullScreen(type){
            if(type){
                this.isFullScreen = true;
            }else{
                this.isFullScreen = false;
            }
          },
          getLicenseErrorMessage(){
            this.getLicensesListFromServer().then((response) => {
              if (Utils.isAcceptedStatusCode(response.statusCode)) {
                if(response.license.length > 0 && 'message' in response.license[0]){
                  this.licenseExpMess = response.license[0]["message"]
                }
              }
            });
          },  
          setUpSettingsSideMenu(sideMenuList){
            for (let sideMenu of sideMenuList) {
              if(this.licenseExpMess && sideMenu != "system"){
                continue;
              }
              if (sideMenu == "metadata" && this.isEnabled('metadata')){
                let metadataEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToMetadata,
                  "handler_args":[]
              }]
                //  let metadata = new SettingsSideMenu("metadata", "metadata", "Metadata", Utils.getMetadatIcon,metadataEvents)
                let metadata = new SettingsSideMenu("metadata", "metadata", "Tag", Utils.getMetadatIcon,metadataEvents)
                metadata.register()
              }
  
              if(sideMenu == "alias" && this.isEnabled('manage-search-alias')){
                let events = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToAlias,
                  "handler_args":[]
              }]
                let metadata = new SettingsSideMenu("alias", "alias", "Alias", Utils.getAliasIcon,events)
                metadata.register()
                continue;
              }
              if (sideMenu == "user" && this.isEnabled("manage-users")){
                let userEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToUsers,
                  "handler_args":[]
                }]
                let users = new SettingsSideMenu("user", "user", "User", Utils.getUsersIcon,userEvents)
                users.register()
              }
              if (sideMenu == "bin" && this.isEnabled('manage-bins')){
                let binsEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToBins,
                  "handler_args":[]
                }]
                let bins = new SettingsSideMenu("bin", "bin", "Bin", Utils.getBinsSvg,binsEvents)
                bins.register()
              }
  
              //************ AI and it can be remove once supported from plugin side **************** */
            //   if (sideMenu == "AI" && this.isEnabled('Train Data Set')){
            //     let binsEvents = [{
            //       "event_name": "onClick",
            //       "event_handler": this.changeComponentToAI,
            //       "handler_args":[]
            //     }]
            //     let bins = new SettingsSideMenu("AI", "AI", "AI", Utils.getBinsSvg,binsEvents)
            //     bins.register()
            //   }
              //*********************************** */
  
              if(sideMenu == "field" && this.isEnabled('manage-fields')){
                let screenEvents = [{
                  "event_name": "onClick",
                  "event_handler":this.changeComponentToFields,
                  "handler_args":[]
                }]
                let screens = new SettingsSideMenu("field", "field", "Field", Utils.getFieldsSvg,screenEvents, "settings-field")
                screens.register()
              }
              if(sideMenu == "screen" && this.isEnabled('manage-screens')){
                let screenEvents = [{
                  "event_name": "onClick",
                  "event_handler":this.changeComponentToScreens,
                  "handler_args":[]
                }]
                let screens = new SettingsSideMenu("screen", "screen", "Screen", Utils.getScreensSvg,screenEvents, "settings-screen")
                screens.register()
              }
              if(sideMenu == "screen profile" && this.isEnabled('manage-screen-profiles') && this.isProfileConfigured()){
                let screenEvents = [{
                  "event_name": "onClick",
                  "event_handler":this.changeComponentToScreenProfiles,
                  "handler_args":[]
                }]
                let screens = new SettingsSideMenu("screenprofile", "screen profile", "Screen profile", Utils.getScreensScreenProfileSvg,screenEvents, "settings-screenprofile")
                screens.register()
              }
              if (sideMenu == "system" && this.isUserTypeAdministrator()){
                let systemEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToSystem,
                  "handler_args":[]
                }]
                let system = new SettingsSideMenu("system", "system", "System", Utils.getSystemSvg,systemEvents)
                system.register()
              }
              if (sideMenu == "import" && (this.getRegisteredImportExportMenus().length > 0 )){
                let showImport = false
                for (let menu of this.getRegisteredImportExportMenus()) {
                  console.log("menu",menu)
                  if (this.isEnabled(menu.privilege)){
                    showImport = true
                    break
                  }
                }
                if (showImport){
                let importEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToImport,
                  "handler_args":[]
                }]
                let import_sidemenu = new SettingsSideMenu("import", "import", "Import/Export", Utils.getImportSvg, importEvents)
                import_sidemenu.register()
                }
              }
  
  
              // if (sideMenu == "web hook"){
              //   let webhookEvents = [{
              //     "event_name": "onClick",
              //     "event_handler": this.changeComponentTowebhook,
              //     "handler_args":[]
              //   }]
              //   let webhook_sidemenu = new SettingsSideMenu("webhook", "webhook", "Web Hook", Utils.getWebhookSvg, webhookEvents)
              //   webhook_sidemenu.register()
              // }
              
              if (sideMenu == "Web hook" && this.isEnabled("manage-webhooks")){
                let webhookEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentTowebhook,
                  "handler_args":[]
                }]
                let webhook_sidemenu = new SettingsSideMenu("webhook", "webhook", "Web hook", Utils.getWebhookSvg,webhookEvents)
                webhook_sidemenu.register()
              }
  
              if (sideMenu == "scheduler" && this.isUserTypeAdministrator() && this.isEnabled("schecule-tasks")){
                let schedulerEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToScheduler,
                  "handler_args":[]
                }]
                let scheduler_sidemenu = new SettingsSideMenu("scheduler", "scheduler", "Scheduler", Utils.getSchedulerSvg,schedulerEvents)
                scheduler_sidemenu.register()
              }
  
            //    if (sideMenu == "media pipeline" && this.isEnabled("Media Pipeline")){
            //      let mediaPipelineEvents = [{
            //        "event_name": "onClick",
            //        "event_handler": this.changeComponentToMediaPipeline,
            //        "handler_args":[]
            //      }]
            //      let mediapipeline_sidemenu = new SettingsSideMenu("mediapipeline", "mediapipeline", "Media Pipeline", Utils.getMediaPipelineSvg,mediaPipelineEvents)
            //      mediapipeline_sidemenu.register()
            //    }
  
              if (sideMenu == "buttons"  && this.isEnabled("manage-buttons")){
                let buttonsEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToButtons,
                  "handler_args":[]
                }]
                let buttons_sidemenu = new SettingsSideMenu("buttons", "buttons", "Buttons", Utils.getButtonsSvg,buttonsEvents)
                buttons_sidemenu.register()
              }

              if (sideMenu == "license" && this.isUserTypeAdministrator()){
                let licenseEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToLicense,
                  "handler_args":[]
                }]
                let license_sidemenu = new SettingsSideMenu("license", "license", "License", Utils.getLicenseSvg,licenseEvents)
                license_sidemenu.register()
              }

              if (sideMenu == "labels" && this.isEnabled("manage-labels")){
                let labelEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToLabels,
                  "handler_args":[]
                }]
                let label_sidemenu = new SettingsSideMenu("labels", "labels", "Labels", Utils.getLabelsSvg,labelEvents)
                label_sidemenu.register()
              }
  
  
              if (sideMenu == "Asset Link Types" && this.isEnabled("manage-assets-links")){
                let systemEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToAssetLinkTypes,
                  "handler_args":[]
                }]
                let system = new SettingsSideMenu("assetlinktypes", "assetlinktypes", "Asset Link Types", Utils.getCopyLinkSvg,systemEvents)
                system.register()
              }
              if (sideMenu == "plugins" && this.isEnabled("manage-plugins")){
                let pluginEvents = [{
                  "event_name": "onClick",
                  "event_handler": this.changeComponentToPlugins,
                  "handler_args":[]
                }]
                let plugin = new SettingsSideMenu("plugin", "plugins", "Plugins", Utils.getPluginSvg,pluginEvents)
                plugin.register()
              }
              
            }
        },
        getEventHandler(eventname,supportedEvents,pluginInfo){
          // this.selectedPluginInfo = null;
          if(this.sideMenuListIds.includes(pluginInfo.id)){
             let event = supportedEvents.filter((eventInfo) => eventInfo.event_name == eventname);
                if(event.length != 0){
                    return event[0]["event_handler"]();
                }
            }else if(pluginInfo){
              this.selectedPluginInfo = Object.assign({}, pluginInfo);
              return this.changeComponentToExternalPlugin(pluginInfo.id)
            }
        },
        handleUrlChange(){
            if (!(this.isClosed)){
              let fileInfo = Utils.getHashLocationForBinBrowse()
              let catalogInfo = Utils.getHashLocationForCatalogBrowse()
              let settingsInfo = Utils.getHashLocationForSettings()
              if (Object.keys(fileInfo).length != 0) {
                this.close()
              }else if (Object.keys(catalogInfo).length != 0) {
                this.close()
              }else if (Object.keys(settingsInfo).length != 0) {
                this.changeToSelectedComponent(settingsInfo.settings_id,settingsInfo.id);
              }else{
                this.close()
              }
            }
          },
          isUserTypeAdministrator(){
            return Utils.isUserTypeAdmin(this.getLoggedInUserType());
          },
          reloadSettingsSideMenuList(){
            // let privilegeAndComponentMap = {metadata:'settings-metadata',user:'settings-user',bin:'settings-bin',field:'settings-field',screen:'settings-screen',screenprofile:'settings-screenprofile',import:'settings-import',system:'settings-system',plugin:'settings-plugin'};
            this.unSetSettingsSidemenu();
            this.$nextTick(()=>{
                this.setUpSettingsSideMenu(this.sideMenuList);
                setTimeout(() => {
                    let foundIndex = this.getRegisteredSettingsSidemenu().findIndex((obj) => obj.id === this.getSelectedSettingsSidemenu);
                    if(foundIndex >= 0 && this.getRegisteredSettingsSidemenu().length){
                      let menuObj = this.getRegisteredSettingsSidemenu()[foundIndex];
                      if(this.sideMenuListIds.includes(menuObj.id)){
                          this.setSelectedSettingsSidemenu(menuObj.id);
                          if(menuObj.componentName != '') this.selectedComponent = menuObj.componentName;
                          if(this.getSelectedSettingsSidemenu == "metadata"){
                            this.changeComponentToMetadata()
                          }if(this.getSelectedSettingsSidemenu == "alias"){
                            this.changeComponentToAlias();
                          }else if(this.getSelectedSettingsSidemenu == "user"){
                            this.changeComponentToUsers();
                          }else if(this.getSelectedSettingsSidemenu == "bin"){
                            this.changeComponentToBins();
                          }else if(this.getSelectedSettingsSidemenu == "AI"){
                            this.changeComponentToAI();
                          }else if(this.getSelectedSettingsSidemenu == "screen"){
                            this.changeComponentToScreens();
                          }else if(this.getSelectedSettingsSidemenu == "screenprofile"){
                            this.changeComponentToScreenProfiles();
                          }else if(this.getSelectedSettingsSidemenu == "import"){
                            this.changeComponentToImport();
                          }else if(this.getSelectedSettingsSidemenu == "webhook"){
                            this.changeComponentTowebhook();
                          }else if(this.getSelectedSettingsSidemenu == "scheduler"){
                            this.changeComponentToScheduler();
                          }else if(this.getSelectedSettingsSidemenu == "mediapipeline"){
                            this.changeComponentToMediaPipeline();
                          }
                          else if(this.getSelectedSettingsSidemenu == "system"){
                            this.changeComponentToSystem();
                          }else if(this.getSelectedSettingsSidemenu == "labels"){
                            this.changeComponentToLabels();
                          }else if(this.getSelectedSettingsSidemenu == "assetlinktypes"){
                            this.changeComponentToAssetLinkTypes();
                          }else if(this.getSelectedSettingsSidemenu == "plugin"){
                            this.changeComponentToPlugins();
                          }else if(this.getSelectedSettingsSidemenu == "buttons"){
                            this.changeComponentToButtons();
                          }else if(this.getSelectedSettingsSidemenu == "license"){
                            this.changeComponentToLicense();
                          }
                      }else{
                          this.selectedPluginInfo = Object.assign({}, menuObj);
                          this.changeComponentToExternalPlugin(menuObj.id);
                      }
                    }else{
                      this.setFirstPanelToRoute();
                    }
                },200);
            });
            
          },
          setFirstPanelToRoute(){
            let firstPanel = this.getRegisteredSettingsSidemenu().filter((panel)=>panel.id=="settings-metadata")
            if (firstPanel.length != 0){
              firstPanel = firstPanel[0]
            }else{
              firstPanel = this.getRegisteredSettingsSidemenu()[0]
            }
            this.getEventHandler('onClick', firstPanel.onEvents, firstPanel)
          },
          ...mapActions("privileges", ["getUserSettingsPrivilege"]),
          ...mapGetters("users",["getLoggedInUserPrivilege"]),
          ...mapMutations("locations", ["setLocationHash", "resetToOldCallback","changeLocationCallback", "unsetLocationChangeEventListenerCallback"]),
          ...mapActions("privileges", ["getUserSettingsPrivilege"]),
          ...mapGetters("users",["getLoggedInUserPrivilege","getLoggedInUserType"]),
          ...mapGetters("registry",["getRegisteredSettingsSidemenu", "getRegisteredImportExportMenus"]),
          ...mapMutations("registry",["unSetSettingsSidemenu"]),
          ...mapMutations("settings",["setSelectedSettingsSidemenu","unsetSelectedSettingsSidemenu"]),
          ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
          ...mapActions("settings", ["getLicensesListFromServer"]),
      },
      mounted(){
        this.setUpSettingsSideMenu(this.sideMenuList);
        if (this.$route.params && this.$route.params.requestedRoute && Object.keys(this.$route.params.requestedRoute).length != 0 && 
            this.$route.params.requestedRoute.matched[this.$route.params.requestedRoute.matched.length-1].parent.name == "settings"){
          this.changeToSelectedComponent(this.$route.params.requestedRoute.name, 
             this.$route.params.pluginId?this.$route.params.pluginId:this.$route.params.requestedRoute.name.split("-")[1]
             , true)
        }else if(this.getRegisteredSettingsSidemenu().length !=0){
          this.setFirstPanelToRoute()
        }
      },
    created(){
      // this.handleUrlChange()
      this.getLicenseErrorMessage();
      Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
      this.getUserSettingsPrivilege().then((data)=>{
        this.userSettings = data
      })
    },
  }
  </script>
  
  
  <style scoped lang="scss">
      $border-color: 1px solid #4a4a4a;
      $border-color-only:#4a4a4a;
      $primary-background: #1a1e21;
      $secondary-background-color:#15181B;
      $bg-color-on-hover: #22272b;
      $text-color: #eee;
      $dull-text-color: #757575;
      $secondary-text-color: #9c9c9c;
      $active-blue : #007bff;
      $input-field-and-label-font-size:14px;
      $input-field-height:38px;
      $none-text-color:#4f4f4f;
      $input-field-padding:.375rem 10px;
      $scrollbar-thumb-background:#333;
      $scrollbar-track-background:#1a1e21;
      $scrollbar-thumb-on-hover-background:#555;
      $tags-background-color:#282d31;
      $tags-border-color:#363636;
      $metadata-border-color-on-hover: #5a5a5a;
      $secondary-border-color: 1px solid #2b2b2b;
      $active-green-color:#28a745;
      $svg-color:#666;
      $learn-about-text-color-hover:#b7b327;
      $learn-about-text-color:#9a9620;
      $icon-hover:#2c3339;
  
      .sidebar-wrapper{
        background: $secondary-background-color;
        overflow:auto;
      }
  
  .sidebar-menu{
    background: $secondary-background-color;
    border-inline-end: 1px solid #2b2b2b;
  }
  .modal{
        display:block;        
    }
  
  .modal-title{
    margin-top:10px !important;
  }
    
    .modal-dialog {
      max-width:100%;
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
    }
    
    .modal-content {
      height: 100%;
      min-height: 100%;
      border: 0 none;
      border-radius: 0;
      box-shadow: none;
      pointer-events: all;
      background:$primary-background !important;
    }
  
    .modal-header,.modal-footer{
      border: $secondary-border-color !important;
      background: $secondary-background-color;
  }
  
  .modal-header{
    height:65px;
  }
  .modal-body {
    height:calc(100% - 65px);
    display:inline-block;
    width:100%;
  
  }
  .modal-header .close {
      // margin: -1rem -13px -1rem auto !important;
      padding:0px;
      margin:0px !important;
  }
  .activeclass{
      background: $primary-background!important;
    .option-label{
      color: $active-blue !important;
      fill: $active-blue !important;
      svg{
        color: $active-blue !important;
        fill:$active-blue !important;
      }
    }
  }
  
  .sidenav{
      height: 100%;
      border-top: none;
      padding:0px !important;
  .sidebar{
      background: $secondary-background-color;
      color: #9c9c9c;
      height:45px;
      padding: 0px 24px !important;
      display: flex;
      align-items: center;
      border-radius: 10px;
      li.sidebar{
        height:40px;
      }
      .option-label{
        color:#9c9c9c;
        font-size: 16px;
      }
  }
  li.sidebar:hover{
      color: $text-color !important;
      font-weight: 500;
      background: $primary-background!important;
      .option-label{
        color: $text-color !important;
      }
  }
  }
  
  svg{
    height:15px !important;
    width:15px !important;
    margin-inline-start:4px;
  }
  
  .border{
      border: $border-color !important;
  }
  
  .close-icon:hover{
    background: $icon-hover;
    border-radius: 20px;
  }
  
  /* width */
  ::-webkit-scrollbar {
    width: 8px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }
  </style>